// JAI BAJARANG BALI KI JAI.
import React, { Suspense } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "react-phone-input-2/lib/style.css";
import "react-quill/dist/quill.snow.css";
import "./scss/main.scss";
import configureStoreProd from "./Pages/config/configureStore.prod";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ToastContainer } from "react-toastify";
import { lazy } from "react";
import { useEffect } from "react";
import socketModel from "./models/socketModel";
import ScrollToTop from "./Pages/ScrollToTop";
import CookieBanner from "./components/CookiesBanner/CookieBanner";
const { persistor, store } = configureStoreProd();

function App() {
  useEffect(() => {
    socketModel.connect();
    socketModel.on("connect", () => {});
    return () => {
      socketModel.disconnect();
    };
  }, []);

  window.addEventListener("error", function (e) {
    if (
      e?.message?.includes("Loading chunk") ||
      e?.message?.includes("ChunkLoadError")
    ) {
      window.location.reload();
    }
  });

  const routes = [
    { url: "/login", path: "Login" },
    { url: "/signup", path: "Signup" },
    { url: "/", path: "Home" },
    { url: "/", element: <Navigate to="/" /> },
    { url: "/dashboard", path: "Dashboard" },
    { url: "/dashboard/business", path: "Dashboardbusiness" },

    { url: "*", path: "NotFoundPage" },
    { url: "/profile", path: "Profile" },
    { url: "/profile/:tab", path: "Settings" },
    { url: "/forgotpassword", path: "Forgotpassword" },
    { url: "/resetpassword", path: "Resetpassword" },

    { url: "/job", path: "Jobs" },
    { url: "/job/edit/:id", path: "Jobs/AddEdit" },
    { url: "/job/add", path: "Jobs/AddEdit" },
    { url: "/job/detail/:id", path: "Jobs/View" },
    { url: "/complete/job/:id?", path: "CompoleteJob" },

    { url: "/project", path: "Projects" },
    { url: "/project/edit/:id", path: "Projects/AddEdit" },
    { url: "/project/add", path: "Projects/AddEdit" },
    { url: "/project/detail/:id", path: "Projects/View" },

    // { url: "/blogs", path: "Blogs" },
    // { url: "/blog-detail/:id", path: "Blogs/View" },

    { url: "/contactus", path: "Contactus" },
    { url: "/about-us", path: "Aboutus" },
    { url: "/privacy", path: "Privacy" },
    { url: "/terms", path: "Terms" },
    { url: "/cookie-policies", path: "Cookie" },
    { url: "/data-processing-agreement", path: "Dataprocessing" },
    { url: "/cancelpayment", path: "CancelPayment" },
    { url: "/estimate/status", path: "Estimatestatus" },

    { url: "/transaction", path: "Transaction" },
    { url: "/transaction/business", path: "Transactionbusiness" },

    { url: "/payslip", path: "ContractorTransaction" },
    { url: "/report", path: "Reports" },
    { url: "/plans", path: "Plans" },
    { url: "/success", path: "Success" },
    { url: "/cancel", path: "Cancel" },
    { url: "/subscriptions", path: "PlanTransaction" },

    { url: "/project/business", path: "Projectsbusiness" },
    { url: "/project/business/edit/:id", path: "Projectsbusiness/AddEdit" },
    { url: "/project/business/add", path: "Projectsbusiness/AddEdit" },
    { url: "/project/business/detail/:id", path: "Projectsbusiness/View" },

    { url: "/user", path: "Users" },
    { url: "/user/edit/:id", path: "Users/AddEdit" },
    { url: "/user/add", path: "Users/AddEdit" },
    { url: "/user/detail/:id", path: "Users/View" },

    { url: "/contractor", path: "Contractors" },
    { url: "/contractor/edit/:id", path: "Contractors/AddEdit" },
    { url: "/contractor/add", path: "Contractors/AddEdit" },
    { url: "/contractor/detail/:id", path: "Contractors/View" },
    { url: "/contractor/request/:id", path: "Contractors/Request" },

    { url: "/skill", path: "Skills" },
    { url: "/skill/edit/:id", path: "Skills/AddEdit" },
    { url: "/skill/add", path: "Skills/AddEdit" },
    { url: "/skill/detail/:id", path: "Skills/View" },

    { url: "/invoice", path: "Invoice" },
    { url: "/invoice/edit/:id", path: "Invoice/AddEdit" },
    { url: "/invoice/add", path: "Invoice/AddEdit" },
    { url: "/invoice/detail/:id", path: "Invoice/View" },

    { url: "/supplier", path: "Suppliers" },
    { url: "/supplier/edit/:id", path: "Suppliers/AddEdit" },
    { url: "/supplier/add", path: "Suppliers/AddEdit" },
    { url: "/supplier/detail/:id", path: "Suppliers/View" },

    { url: "/tools-supplier", path: "SuppliersTools" },
    { url: "/tools-supplier/edit/:id", path: "SuppliersTools/AddEdit" },
    { url: "/tools-supplier/add", path: "SuppliersTools/AddEdit" },
    { url: "/tools-supplier/detail/:id", path: "SuppliersTools/View" },

    { url: "/role", path: "Roles" },
    { url: "/role/edit/:id", path: "Roles/AddEdit" },
    { url: "/role/add", path: "Roles/AddEdit" },
    { url: "/role/detail/:id", path: "Roles/View" },

    { url: "/material", path: "Materials" },
    { url: "/material/edit/:id", path: "Materials/AddEdit" },
    { url: "/material/add", path: "Materials/AddEdit" },
    { url: "/material/detail/:id", path: "Materials/View" },

    { url: "/category", path: "Category" },
    { url: "/category/edit/:id", path: "Category/AddEdit" },
    { url: "/category/add", path: "Category/AddEdit" },
    { url: "/category/detail/:id", path: "Category/View" },

    { url: "/content", path: "Content" },
    { url: "/content/detail/:slug", path: "Content/View" },
    { url: "/content/add", path: "Content/AddEdit" },
    { url: "/content/edit/:slug", path: "Content/AddEdit" },

    { url: "/customers", path: "Customers" },
    { url: "/customers/edit/:id", path: "Customers/AddEdit" },
    { url: "/customers/add", path: "Customers/AddEdit" },
    { url: "/customers/detail/:id", path: "Customers/View" },

    { url: "/cis", path: "CisTax" },
    { url: "/cis/edit/:id", path: "CisTax/AddEdit" },
    { url: "/cis/add", path: "CisTax/AddEdit" },
    { url: "/cis/detail/:id", path: "CisTax/View" },

    { url: "/travel", path: "Travelrate" },
    { url: "/travel/edit/:id", path: "Travelrate/AddEdit" },
    { url: "/travel/add", path: "Travelrate/AddEdit" },
    { url: "/travel/detail/:id", path: "Travelrate/View" },

    { url: "/contactus", path: "Contactus" },
    { url: "/contactus/edit/:id", path: "Contactus/AddEdit" },
    { url: "/contactus/add", path: "Contactus/AddEdit" },
    { url: "/contactus/detail/:id", path: "Contactus/View" },

    { url: "/payable", path: "Payable" },
    { url: "/payable/edit/:id", path: "Payable/AddEdit" },
    { url: "/payable/add", path: "Payable/AddEdit" },
    { url: "/payable/detail/:id/:jobid?", path: "Payable/View" },

    { url: "/vat", path: "Vat" },
    { url: "/vat/edit/:id", path: "Vat/AddEdit" },
    { url: "/vat/add", path: "Vat/AddEdit" },
    { url: "/vat/detail/:id", path: "Vat/View" },
    { url: "/generate/invoice/:id", path: "InvoiceGenerate" },
    { url: "/pay/:id?", path: "Paynow" },
    { url: "/schedule", path: "Schedule/AddEdit" },

    { url: "/company", path: "Company" },
    { url: "/custom/report", path: "Calendar/CustomScheduleCalendar" },
    { url: "/complete/business/job/:id?", path: "CompoleteJobbusiness" },
    { url: "/create/payslip/:id/:sdate/:edate?", path: "Payslippage" },
    // { url: "/create/payslip/:id/:sdate/:edate?", path: "Payslippage" },

    { url: "/accountant", path: "Accountant" },
    { url: "/accountant/edit/:id", path: "Accountant/AddEdit" },
    { url: "/accountant/add", path: "Accountant/AddEdit" },
    { url: "/accountant/detail/:id", path: "Accountant/View" },

    { url: "/job/business", path: "Jobsbusiness" },
    { url: "/job/business/edit/:id", path: "Jobsbusiness/Edit" },
    { url: "/job/business/add", path: "Jobsbusiness/AddEdit" },
    { url: "/job/business/detail/:id?", path: "Jobsbusiness/View" },

    { url: "/generate/invoice/:id", path: "InvoiceGenerate" },
    { url: "/edit/invoice/:id", path: "Editsaveinvoice" },
    { url: "/schedule", path: "Schedule/AddEdit" },
    { url: "/custom/report", path: "Calendar/CustomScheduleCalendar" },

    { url: "/payslip/business/:id?", path: "Paysliplist" },
    { url: "/active/plan", path: "ActivePlan" },
    { url: "/report", path: "Reports" },
    { url: "/workingweek", path: "WorkingWeek/WorkingWeekcon" },

    { url: "/order", path: "OrderMaterials" },
    { url: "/order/add", path: "OrderMaterials/AddEdit" },
    { url: "/order/add", path: "OrderMaterials/AddEdit" },
    { url: "/order/add/:id?", path: "OrderMaterials/AddEdit" },
    { url: "/order/detail/:id/:tab?", path: "OrderMaterials/View" },

    { url: "/request/materials", path: "RequestMaterials" },
    { url: "/request/materials/add", path: "RequestMaterials/AddEdit" },
    {
      url: "/request/materials/edit/:id/:tab?",
      path: "RequestMaterials/AddEdit",
    },
    {
      url: "/accept/van/material/:id/:tab?",
      path: "RequestMaterials/VanAddEdit",
    },
    {
      url: "/request/materials/detail/:id/:tab?",
      path: "RequestMaterials/View",
    },

    { url: "/create/payslip/manual", path: "Payslipnonworked" },

    { url: "/tools", path: "Tools" },
    { url: "/tools/add", path: "Tools/AddEdit" },
    { url: "/tools/edit/:id?", path: "Tools/AddEdit" },
    { url: "/tools/detail/:id?", path: "Tools/View" },

    { url: "/reminder", path: "Reminder" },
    { url: "/reminder/edit/:id", path: "Reminder/AddEdit" },
    { url: "/reminder/add", path: "Reminder/AddEdit" },
    { url: "/reminder/detail/:id", path: "Reminder/View" },

    { url: "/saved-report/preview", path: "ReportPreview" },
    { url: "/saved-report/preview/:id?", path: "ReportPreview" },
    { url: "/registering/costs/:id?", path: "InsertMaterial" },

    { url: "/service", path: "OtherServices" },
    { url: "/service/edit/:id", path: "OtherServices/AddEdit" },
    { url: "/service/add", path: "OtherServices/AddEdit" },
    { url: "/service/detail/:id", path: "OtherServices/View" },

    { url: "/expense/log", path: "ExpenseLog" },
    { url: "/expense/log/edit/:id", path: "ExpenseLog/Edit" },
    { url: "/expense/log/add", path: "ExpenseLog/AddEdit" },
    { url: "/expense/log/detail/:id", path: "ExpenseLog/View" },

    { url: "/statistics", path: "CompanyCosts" },

    { url: "/spending", path: "CompanySpending" },
    { url: "/spending/edit/:id", path: "CompanySpending/AddEdit" },
    { url: "/spending/add", path: "CompanySpending/AddEdit" },
    { url: "/spending/detail/:id", path: "CompanySpending/View" },

    { url: "/interim/invoice/:id", path: "InterimInvoice" },

    { url: "/working/week", path: "WorkingWeek/WorkingWeek" },

    { url: "/estimate", path: "Estimating" },
    { url: "/estimate/add", path: "Estimating/AddEdit" },
    { url: "/estimate/edit/:id?", path: "Estimating/AddEdit" },
    { url: "/estimate/duplicate/:id?", path: "Estimating/Duplicate" },
    { url: "/estimate/detail/:id?", path: "Estimating/View" },
    { url: "/estimate/report/:id?", path: "Estimating/Report" },

    { url: "/job/configuration", path: "JobConfiguration" },
    { url: "/job/configuration/add", path: "JobConfiguration/AddEdit" },
    { url: "/job/configuration/edit/:id?", path: "JobConfiguration/AddEdit" },
    { url: "/job/configuration/detail/:id?", path: "JobConfiguration/View" },

    { url: "/cost/register", path: "ResiterCost" },
    { url: "/cost/register/add", path: "ResiterCost/AddEdit" },
    { url: "/cost/register/edit/:id?", path: "ResiterCost/AddEdit" },
    { url: "/cost/register/detail/:id?", path: "ResiterCost/View" },

    { url: "/inv/reports", path: "InvoiceReport" },
    { url: "/commaninv/:id/:type", path: "InvoiceForAll" },

    { url: "/client/feedback/:id/:userId", path: "ClientReview" },
    { url: "/review", path: "FeedBacks" },
    { url: "/review/detail/:id?", path: "FeedBacks/View" },
    { url: "/feedback/status", path: "FeedBackStatus" },

    { url: "/rewards", path: "Rewards" },
    { url: "/rewards/detail/:id?", path: "Rewards/View" },

    { url: "/email/template", path: "EmailTempletsall" },
    { url: "/email/template/copy/:id?", path: "EmailTempletsall/Duplicate" },
    { url: "/email/template/add", path: "EmailTempletsall/AddEdit" },
    { url: "/email/template/edit/:id?", path: "EmailTempletsall/AddEdit" },
    { url: "/email/template/detail/:id?", path: "EmailTempletsall/View" },

    { url: "/settings", path: "RewardSetting" },
    { url: "/settings/add", path: "RewardSetting/AddEdit" },
    { url: "/settings/edit/:id?", path: "RewardSetting/AddEdit" },
    { url: "/settings/detail/:id?", path: "RewardSetting/View" },

    { url: "/leaves", path: "Leaves" },
    { url: "/leaves/add", path: "Leaves/AddEdit" },
    { url: "/leaves/edit/:id?", path: "Leaves/AddEdit" },
    { url: "/leaves/detail/:id?", path: "Leaves/View" },

    { url: "/contract/template", path: "ContractTemplate" },
    { url: "/contract/template/add", path: "ContractTemplate/AddEdit" },
    { url: "/contract/template/edit/:id?", path: "ContractTemplate/AddEdit" },
    { url: "/contract/template/copy/:id?", path: "ContractTemplate/Duplicate" },
    { url: "/contract/template/detail/:id?", path: "ContractTemplate/View" },

    { url: "/reject/estimate/:id", path: "Estimating/RejectReason" },
    { url: "/estimate/inv/:id", path: "Estimating/EstimateInvoice" },
    { url: "/send/estimate/:id", path: "Estimating/SendEmail" },
    { url: "/message/board/:jobId?", path: "ChatBoard" },
    { url: "/otp", path: "Otp" },

    { url: "/breakers", path: "CertificateCircuitBreaker" },
    { url: "/breakers/add", path: "CertificateCircuitBreaker/AddEdit" },
    { url: "/breakers/edit/:id?", path: "CertificateCircuitBreaker/AddEdit" },
    { url: "/breakers/detail/:id?", path: "CertificateCircuitBreaker/View" },

    { url: "/circuit", path: "CircuitBreaker" },
    { url: "/circuit/add", path: "CircuitBreaker/AddEdit" },
    { url: "/circuit/edit/:id?", path: "CircuitBreaker/AddEdit" },
    { url: "/circuit/detail/:id?", path: "CircuitBreaker/View" },

    { url: "/manufacturer", path: "Manufacturer" },
    { url: "/manufacturer/edit/:id", path: "Manufacturer/AddEdit" },
    { url: "/manufacturer/add", path: "Manufacturer/AddEdit" },
    { url: "/manufacturer/detail/:id", path: "Manufacturer/View" },

    { url: "/notifications", path: "Notifications" },
    { url: "/project/alert", path: "ProjectAlert" },
    { url: "/project/alert/detail/:id", path: "ProjectAlert/View" },
    { url: "/outstanding/revenue", path: "OutstandingRevenue" },

    { url: "/success-story", path: "CaseStudy" },
    { url: "/success-story/detail/:id?", path: "CaseStudy/View" },

    { url: "/certificates", path: "Certificates" },
    { url: "/certificates/copy/:id?", path: "Certificates/Duplicate" },
    { url: "/certificates/add", path: "Certificates/AddEdit" },
    { url: "/certificates/edit/:id?", path: "Certificates/AddEdit" },
    { url: "/certificates/detail/:id?", path: "Certificates/View" },
    { url: "/fill/form/:id?", path: "Certificates/FillForm" },
    { url: "/edit/form/:id?", path: "Certificates/EditForm" },

    { url: "/profit/summary", path: "ClientProfit" },

    { url: "/notes", path: "NotesTemplate" },
    { url: "/notes/add", path: "NotesTemplate/AddEdit" },
    { url: "/notes/edit/:id?", path: "NotesTemplate/AddEdit" },
    { url: "/notes/detail/:id?", path: "NotesTemplate/View" },

    { url: "/issued/certificate", path: "IssuedCertificate" },
    { url: "/issued/certificate/detail/:id?", path: "IssuedCertificate/View" },
    { url: "/business/documents", path: "BusinessDocs" },

    { url: "/van", path: "Vans" },
    { url: "/van/add", path: "Vans/AddEdit" },
    { url: "/van/edit/:id?", path: "Vans/AddEdit" },
    { url: "/van/detail/:id?", path: "Vans/View" },
  ];

  return (
    <>
      <CookieBanner />
      <Provider store={store}>
        <PersistGate loading={"loading ..."} persistor={persistor}>
          <Suspense
            fallback={
              <div id="loader" className="loaderDiv">
                <div>
                  <img
                    src="/assets/img/loader.gif"
                    alt="logo"
                    className="loaderlogo"
                  />
                </div>
              </div>
            }
          >
            <Router>
              <ScrollToTop />
              <Routes>
                {routes.map((itm, index) => {
                  const Element = lazy(() => import(`./Pages/${itm.path}`));
                  return (
                    <Route
                      key={`${index}_${itm.url}`}
                      path={itm.url}
                      element={itm.path ? <Element /> : itm.element}
                    />
                  );
                })}
              </Routes>
            </Router>
          </Suspense>
        </PersistGate>
      </Provider>
      <div id="loader" className="loaderDiv d-none">
        <div>
          <img src="/assets/img/loader.gif" alt="logo" className="loaderlogo" />
        </div>
      </div>
      <ToastContainer position="top-right" />
    </>
  );
}

export default App;
